import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../services/dataService';

function ProtectedRoute({ children, requiredRole }) {
  const [status, setStatus] = useState('checking');
  const user = JSON.parse(localStorage.getItem('user') || 'null');

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setStatus(session ? 'ok' : 'unauth');
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setStatus(session ? 'ok' : 'unauth');
    });

    return () => subscription.unsubscribe();
  }, []);

  if (status === 'checking') return null;
  if (status === 'unauth') return <Navigate to="/login" replace />;
  if (requiredRole && user?.role !== requiredRole) {
    return <Navigate to={user?.role === 'admin' ? '/admin' : '/cashier'} replace />;
  }

  return children;
}

export default ProtectedRoute;
